/**
 * Number formatting it-IT (thousands with a dot, e.g. 12.000). Implemented without Intl so the
 * output does not depend on the ICU data of the runtime (Node, tablets' browsers).
 */

/**
 * Rounds like an Excel number format: first to 15 significant digits (so 0,575 × 100 =
 * 57.49999999999999 counts as 57,5), then half away from zero.
 */
function excelRound(value: number): number {
  const reduced = Number(value.toPrecision(15));
  return Math.sign(reduced) * Math.round(Math.abs(reduced));
}

/** 12000 → "12.000"; null/undefined → "". Rounds to an integer as Excel does. */
export function formatNumber(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '';
  const rounded = excelRound(value) + 0;
  const digits = String(Math.abs(rounded)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return rounded < 0 ? `-${digits}` : digits;
}

/** Signed number for differences: 538 → "+538", -100 → "-100", 0 → "0". */
export function formatSigned(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '';
  return value > 0 ? `+${formatNumber(value)}` : formatNumber(value);
}

/** 0.94 → "94%"; null → "". */
export function formatPercent(ratio: number | null | undefined): string {
  if (ratio == null || Number.isNaN(ratio)) return '';
  return `${formatNumber(ratio * 100)}%`;
}
